import { get, post } from '../../utils/axios'

export const reportLeaveFullAPI = async (body) => {
  return await get('report/leave/full', body)
}

export const exportReportLeaveFullAPI = async (body) => {
  return await get('excel/leave/full', body)
}

export const exportLeavesCancelAPI = async (body) => {
  return await post('leaves/cancel', body)
}
export const getFileLeavesAPI = async (body) => {
  return await get('leaves/full/detail/file', body)
}
